module.exports = __webpack_public_path__ + "media/images/pic/popup/icon-group-f0a4124571dd6ddaabeb29d061f8f5a3.png";